import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheckIcon, TruckIcon, HeadphonesIcon, AwardIcon, UsersIcon, TargetIcon } from 'lucide-react';
import { Button } from '../components/ui/Button';
export function AboutPage() {
  return <div className="min-h-screen bg-white" data-id="element-879" data-mp="548zrrvursqf">
      {/* Hero */}
      <div className="bg-gradient-to-r from-primary-600 to-primary-800 py-20" data-id="element-880" data-mp="7ijp4k1sx50">
        <div className="max-w-7xl mx-auto px-4 text-center" data-id="element-881" data-mp="3rcs3gehg8f66">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-882" data-mp="3rebloamo10al">
            About Gadgets Zone
          </h1>
          <p className="text-xl text-primary-100 max-w-2xl mx-auto" data-id="element-883" data-mp="3mga0nk5oiqwh">
            Your trusted destination for affordable gadgets and electronics in
            Pakistan
          </p>
        </div>
      </div>

      {/* Story section */}
      <div className="max-w-7xl mx-auto px-4 py-16" data-id="element-884" data-mp="1gl8pcfqtftgr">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-885" data-mp="1giw7e2l25j3p">
          <div data-id="element-886" data-mp="1bmfdssv3acj8">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-887" data-mp="1bjt1kfx978uo">Our Story</h2>
            <div className="space-y-4 text-gray-600" data-id="element-888" data-mp="2euo2c08vn851">
              <p data-id="element-889" data-mp="2jvtu9vupqrdi">
                Founded in 2020, Gadgets Zone started with a simple mission: to
                make quality technology accessible to everyone in Pakistan. We
                believe that great gadgets shouldn't come with a premium price
                tag.
              </p>
              <p data-id="element-890" data-mp="2ykggmhircje8">
                What began as a small online store has grown into one of
                Pakistan's most trusted destinations for electronics and
                gadgets. We've served over 50,000 happy customers across the
                country.
              </p>
              <p data-id="element-891" data-mp="2tti0bhxrrlaz">
                Our team is passionate about technology and dedicated to
                providing exceptional customer service. We carefully curate our
                product selection to ensure you get only the best quality items
                at competitive prices.
              </p>
            </div>
            <Link to="/products" className="inline-block mt-6" data-id="element-892" data-mp="na2uqk6y72">
              <Button variant="primary" size="lg" data-id="element-893" data-mp="3w3f3jx9swzha">
                Explore Our Products
              </Button>
            </Link>
          </div>
          <div className="relative" data-id="element-894" data-mp="3m6k6lit6f754">
            <div className="aspect-square bg-gradient-to-br from-primary-100 to-primary-200 rounded-2xl flex items-center justify-center" data-id="element-895" data-mp="3m9oiz3gsp96v">
              <div className="text-center" data-id="element-896" data-mp="3d7f8uepfvhu0">
                <img src="https://cdn.magicpatterns.com/uploads/fRsBpVfPoCHsQawYgHjccg/ChatGPT_Image_Mar_6,_2026,_03_48_02_AM.png" alt="Gadgets Zone" className="h-32 w-auto object-contain mx-auto mb-4 bg-white rounded-2xl p-2" data-id="element-897" data-mp="3d8gjwj6gg4bq" />
                <p className="text-2xl font-bold text-primary-600" data-id="element-898" data-mp="33erbniujrbur">
                  Gadgets Zone
                </p>
                <p className="text-primary-500" data-id="element-899" data-mp="2tiocmluzrtc1">Since 2020</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Values */}
      <div className="bg-gray-50 py-16" data-id="element-900" data-mp="2pi4dxdurshns">
        <div className="max-w-7xl mx-auto px-4" data-id="element-901" data-mp="14ztlsvrarh9y">
          <div className="text-center mb-12" data-id="element-902" data-mp="14z0n8i2hry2w">
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-903" data-mp="190lzc177c8c1">
              Why Choose Us
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-904" data-mp="1dzp1ndvss0gb">
              We're committed to providing the best shopping experience for our
              customers
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-905" data-mp="lbt5qbe1yckl">
            <div className="bg-white p-6 rounded-xl shadow-card" data-id="element-906" data-mp="qa4hirnwqx5g">
              <div className="w-14 h-14 bg-green-100 rounded-xl flex items-center justify-center mb-4" data-id="element-907" data-mp="q8b9p91k66vv">
                <ShieldCheckIcon className="w-7 h-7 text-green-600" data-id="element-908" data-mp="v7e4m0ntqwq4" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-909" data-mp="101icqn8ttass">
                100% Genuine Products
              </h3>
              <p className="text-gray-600" data-id="element-910" data-mp="7jwj2mv5kuvl">
                Every product we sell is authentic and sourced directly from
                authorized distributors.
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-card" data-id="element-911" data-mp="257gwpeq3oufb">
              <div className="w-14 h-14 bg-blue-100 rounded-xl flex items-center justify-center mb-4" data-id="element-912" data-mp="259bhmt1dgmje">
                <TruckIcon className="w-7 h-7 text-blue-600" data-id="element-913" data-mp="2j06knop6w9f2" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-914" data-mp="2e6lswee6wbob">
                Fast Nationwide Delivery
              </h3>
              <p className="text-gray-600" data-id="element-915" data-mp="2syw2xikzzvvu">
                We deliver to all major cities in Pakistan with free shipping on
                orders over PKR 5,000.
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-card" data-id="element-916" data-mp="31vddajljfpqj">
              <div className="w-14 h-14 bg-primary-100 rounded-xl flex items-center justify-center mb-4" data-id="element-917" data-mp="2wz67cqt56e8l">
                <HeadphonesIcon className="w-7 h-7 text-primary-600" data-id="element-918" data-mp="17jyny3wfvsbb" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-919" data-mp="12m6jkaelydq8">
                24/7 Customer Support
              </h3>
              <p className="text-gray-600" data-id="element-920" data-mp="3eabflxbk672x">
                Our dedicated support team is always ready to help you with any
                questions or concerns.
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-card" data-id="element-921" data-mp="35dudfjl69jjb">
              <div className="w-14 h-14 bg-purple-100 rounded-xl flex items-center justify-center mb-4" data-id="element-922" data-mp="39fpdylva3sw1">
                <AwardIcon className="w-7 h-7 text-purple-600" data-id="element-923" data-mp="2vfwhe9x2mig5" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-924" data-mp="30hdf5wk9dosi">
                Best Price Guarantee
              </h3>
              <p className="text-gray-600" data-id="element-925" data-mp="2mivvc9xh4wfv">
                We offer competitive prices and price matching to ensure you get
                the best deals.
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-card" data-id="element-926" data-mp="kq7m9jy5fes6">
              <div className="w-14 h-14 bg-red-100 rounded-xl flex items-center justify-center mb-4" data-id="element-927" data-mp="opzz48uks73c">
                <UsersIcon className="w-7 h-7 text-red-600" data-id="element-928" data-mp="1xp12zzl4ghsg" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-929" data-mp="1soddxjggeb0v">
                50,000+ Happy Customers
              </h3>
              <p className="text-gray-600" data-id="element-930" data-mp="1ontjwor6fniy">
                Join thousands of satisfied customers who trust Gadgets Zone for
                their tech needs.
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-card" data-id="element-931" data-mp="2gd66r71s42r9">
              <div className="w-14 h-14 bg-teal-100 rounded-xl flex items-center justify-center mb-4" data-id="element-932" data-mp="2ccci2bgiijxb">
                <TargetIcon className="w-7 h-7 text-teal-600" data-id="element-933" data-mp="27lcjz2vnpvt8" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-934" data-mp="22nb04fqepsgp">
                Easy Returns
              </h3>
              <p className="text-gray-600" data-id="element-935" data-mp="302ovu2yfvavt">
                Not satisfied? Return within 7 days for a full refund. No
                questions asked.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Stats */}
      <div className="py-16" data-id="element-936" data-mp="32ozezoqejmry">
        <div className="max-w-7xl mx-auto px-4" data-id="element-937" data-mp="37lprk230008m">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center" data-id="element-938" data-mp="37mhnxf4f61zy">
            <div data-id="element-939" data-mp="3cjznwg0gl6vt">
              <p className="text-4xl md:text-5xl font-bold text-primary-600" data-id="element-940" data-mp="3cjhlt2r47yfz">
                50K+
              </p>
              <p className="text-gray-600 mt-2" data-id="element-941" data-mp="3gkjk9hd7k6gw">Happy Customers</p>
            </div>
            <div data-id="element-942" data-mp="3ll7jurfi5vmq">
              <p className="text-4xl md:text-5xl font-bold text-primary-600" data-id="element-943" data-mp="3ljmox0pa0aoc">
                1000+
              </p>
              <p className="text-gray-600 mt-2" data-id="element-944" data-mp="3vbk2uf7o5gqr">Products</p>
            </div>
            <div data-id="element-945" data-mp="3vdn3ruad0ua9">
              <p className="text-4xl md:text-5xl font-bold text-primary-600" data-id="element-946" data-mp="4598f1x5ze8e">
                50+
              </p>
              <p className="text-gray-600 mt-2" data-id="element-947" data-mp="87cmzzf4qyxw">Brands</p>
            </div>
            <div data-id="element-948" data-mp="84zz75moxucx">
              <p className="text-4xl md:text-5xl font-bold text-primary-600" data-id="element-949" data-mp="d5nui3hycxcy">
                4.8
              </p>
              <p className="text-gray-600 mt-2" data-id="element-950" data-mp="yg2wynej37gr">Average Rating</p>
            </div>
          </div>
        </div>
      </div>

      {/* CTA */}
      <div className="bg-primary-600 py-16" data-id="element-951" data-mp="thjckrfl23qi">
        <div className="max-w-7xl mx-auto px-4 text-center" data-id="element-952" data-mp="18flekx6yuh5n">
          <h2 className="text-3xl font-bold text-white mb-4" data-id="element-953" data-mp="18cz6mwg5xzmw">Ready to Shop?</h2>
          <p className="text-primary-100 mb-8 max-w-2xl mx-auto" data-id="element-954" data-mp="13gicnlma8r1w">
            Explore our wide range of gadgets and electronics. Find the perfect
            tech for your lifestyle.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-955" data-mp="asuu0c4koahw">
            <Link to="/products" data-id="element-956" data-mp="ph94n988d390">
              <Button variant="secondary" size="lg" data-id="element-957" data-mp="phioef2ome69">
                Browse Products
              </Button>
            </Link>
            <Link to="/contact" data-id="element-958" data-mp="3t5at193rc0xt">
              <Button variant="outline" size="lg" className="border-white text-white hover:bg-white/10" data-id="element-959" data-mp="3t495441n7jyo">
                Contact Us
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>;
}